import ClientAgentExtender from '../../../Common/clientAgentExtender'

export default class MednarodnePodatkovneBlokade extends ClientAgentExtender {
  _idPrikljucek = null
  _stevilka = null
  _mozneBlokade = null
  _izbranaBlokada = null
  _trenutnaAktivna = null
  _loadingChange = false

  constructor (idPrikljucek, stevilka) {
    super()
    this._idPrikljucek = idPrikljucek
    this._stevilka = stevilka
  }

  async loadBlokad (override = false) {
    if (this._mozneBlokade === null || override) {
      let response = await this.ca.makeRequest(
        'prikljucek/telefonija/umts/pridobiMednarodnoPodatkovnoBlokado',
        {idPrikljucek: this._idPrikljucek, stevilka: this._stevilka},
        'GET'
      )
      let tmpList = []
      response.data.forEach((element) => {
        tmpList.push({id: element.idUmtsOmejitevSifrant, label: element.naziv})
        if (element.status === 'on') {
          this._izbranaBlokada = element.idUmtsOmejitevSifrant
          this._trenutnaAktivna = element.idUmtsOmejitevSifrant
        }
      })
      this._mozneBlokade = tmpList
    }
  }

  async spremeni () {
    this._loadingChange = true
    if (this._trenutnaAktivna !== this._izbranaBlokada) {
      try {
        await this.ca.makeRequest(
          'prikljucek/telefonija/umts/nastaviMednarodnoPodatkovnoBlokado',
          {idPrikljucek: this._idPrikljucek, stevilka: this._stevilka, mednarodnaPodatkovnaBlokada: this._izbranaBlokada},
          'POST'
        )
        this._trenutnaAktivna = this._izbranaBlokada
      } catch (e) {
        this._loadingChange = false
        throw e
      }
    }
    this._loadingChange = false
  }

  get mozneBlokade () {
    return this._mozneBlokade
  }

  set mozneBlokade (value) {
    this._mozneBlokade = value
  }

  get izbranaBlokada () {
    return this._izbranaBlokada
  }

  set izbranaBlokada (value) {
    this._izbranaBlokada = value
  }

  get trenutnaAktivna () {
    return this._trenutnaAktivna
  }

  set trenutnaAktivna (value) {
    this._trenutnaAktivna = value
  }

  get loadingChange () {
    return this._loadingChange
  }

  set loadingChange (value) {
    this._loadingChange = value
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/Prikljucek/Telefonija/Umts/MednarodnePodatkovneBlokade.js